import { useState } from "react";
import "./Home.css";
import AdminDashboardShell, { AdminShellIcon as Icon } from "./Shell";

const STAT_CARDS = [
  {
    key: "visitors",
    title: "今日访客",
    value: "8,129",
    change: "↑ 12.5%",
    changeTone: "up",
    accent: "blue",
    icon: "users",
    points: [22, 28, 26, 41, 38, 56, 49]
  },
  {
    key: "orders",
    title: "订单数量",
    value: "236",
    change: "↓ 8.3%",
    changeTone: "down",
    accent: "violet",
    icon: "orders",
    points: [54, 48, 52, 44, 41, 36, 40]
  },
  {
    key: "sales",
    title: "销售额",
    value: "¥ 56,782.00",
    change: "↑ 15.6%",
    changeTone: "up",
    accent: "blue",
    icon: "wallet",
    points: [18, 24, 29, 35, 38, 57, 61]
  },
  {
    key: "conversion",
    title: "转化率",
    value: "3.24%",
    change: "↑ 0.8%",
    changeTone: "up",
    accent: "violet",
    icon: "target",
    points: [20, 18, 22, 24, 27, 26, 31]
  }
];

const VISIT_DATES = ["05-10", "05-11", "05-12", "05-13", "05-14", "05-15", "05-16"];
const VISIT_VALUES = [2400, 3800, 4600, 5980, 8763, 7320, 8240];
const TRAFFIC_SOURCES = [
  { label: "直接访问", value: 36.5, color: "#3b82f6" },
  { label: "搜索引擎", value: 28.7, color: "#7c3aed" },
  { label: "社交媒体", value: 16.3, color: "#06b6d4" },
  { label: "外部链接", value: 8.6, color: "#f59e0b" },
  { label: "邮件营销", value: 5.4, color: "#10b981" },
  { label: "其他", value: 4.5, color: "#94a3b8" }
];
const SALES_MONTHS = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
const SALES_VALUES = [28, 36, 42, 61, 56.782, 48, 52, 58, 67, 72, 84, 91];
const TODOS = [
  { id: 1, title: "处理退款申请", detail: "订单号：#20240516001", time: "30 分钟前" },
  { id: 2, title: "审核商品上架", detail: "待审核商品：12 个", time: "1 小时前" },
  { id: 3, title: "回复客户咨询", detail: "未回复消息：8 条", time: "2 小时前" },
  { id: 4, title: "更新系统公告", detail: "公告将于明日过期", time: "1 天前" },
  { id: 5, title: "导出销售报表", detail: "生成 5 月份销售报表", time: "2 天前" }
];
const ANNOUNCEMENTS = [
  { id: 1, tone: "danger", tag: "重要", text: "系统将于 5 月 20 日凌晨升级维护", date: "2024-05-16" },
  { id: 2, tone: "info", tag: "更新", text: "新增多种营销工具，助力业务增长", date: "2024-05-15" },
  { id: 3, tone: "warning", tag: "活动", text: "618 大促活动即将开启，敬请期待！", date: "2024-05-14" }
];
const RECENT_ORDERS = [
  { id: "#20240516001", customer: "张先生", status: "待付款", amount: "¥ 1,299.00", time: "2024-05-16 14:32:21" },
  { id: "#20240516002", customer: "李女士", status: "待发货", amount: "¥ 2,599.00", time: "2024-05-16 13:45:18" },
  { id: "#20240516003", customer: "王先生", status: "已发货", amount: "¥ 899.00", time: "2024-05-16 11:20:36" },
  { id: "#20240516004", customer: "赵女士", status: "已完成", amount: "¥ 1,599.00", time: "2024-05-16 10:05:42" },
  { id: "#20240515001", customer: "陈先生", status: "已取消", amount: "¥ 459.00", time: "2024-05-15 16:30:11" }
];


function MiniSparkline({ points, tone }) {
  const width = 118;
  const height = 48;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;
  const stepX = width / (points.length - 1);
  const path = points
    .map((point, index) => {
      const x = index * stepX;
      const y = height - ((point - min) / range) * (height - 8) - 4;
      return `${index === 0 ? "M" : "L"}${x.toFixed(2)} ${y.toFixed(2)}`;
    })
    .join(" ");

  return (
    <svg className="admin-home-sparkline" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" aria-hidden="true">
      <path className={`admin-home-sparkline-area ${tone}`} d={`${path} L ${width} ${height} L 0 ${height} Z`} />
      <path className={`admin-home-sparkline-line ${tone}`} d={path} />
    </svg>
  );
}

function StatCard({ item }) {
  return (
    <article className={`admin-home-card admin-home-stat-card accent-${item.accent}`}>
      <div className="admin-home-stat-copy">
        <span>{item.title}</span>
        <strong>{item.value}</strong>
        <div className="admin-home-stat-trend-row">
          <span className={`admin-home-stat-trend ${item.changeTone}`}>{item.change}</span>
          <small>较昨日</small>
        </div>
      </div>
      <div className="admin-home-stat-side">
        <div className="admin-home-stat-icon">
          <Icon name={item.icon} />
        </div>
        <MiniSparkline points={item.points} tone={item.accent} />
      </div>
    </article>
  );
}

function DropdownButton({ label, items }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`admin-home-dropdown ${open ? "is-open" : ""}`} onBlur={() => setOpen(false)}>
      <button type="button" className="admin-home-toolbar-button" onClick={() => setOpen((current) => !current)}>
        {label}
        <Icon name="chevron" />
      </button>
      {open ? (
        <div className="admin-home-dropdown-menu">
          {items.map((item) => (
            <button key={item} type="button" className="admin-home-dropdown-option" onMouseDown={(event) => event.preventDefault()} onClick={() => setOpen(false)}>
              {item}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

function ChartToolbar({ items }) {
  return (
    <div className="admin-home-chart-toolbar">
      {items.map((item) => {
        if (Array.isArray(item.options) && item.options.length) {
          return <DropdownButton key={item.label} label={item.label} items={item.options} />;
        }

        return (
          <button key={item.label} type="button" className="admin-home-toolbar-button">
            {item.icon ? <Icon name={item.icon} /> : null}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

function VisitTrendChart() {
  const width = 760;
  const height = 280;
  const padding = { top: 16, right: 18, bottom: 42, left: 44 };
  const innerWidth = width - padding.left - padding.right;
  const innerHeight = height - padding.top - padding.bottom;
  const max = 10000;
  const stepX = innerWidth / (VISIT_VALUES.length - 1);
  const points = VISIT_VALUES.map((value, index) => {
    const x = padding.left + stepX * index;
    const y = padding.top + innerHeight - (value / max) * innerHeight;
    return { x, y, value, label: VISIT_DATES[index] };
  });
  const linePath = points.map((point, index) => `${index === 0 ? "M" : "L"}${point.x} ${point.y}`).join(" ");
  const areaPath = `${linePath} L ${padding.left + innerWidth} ${padding.top + innerHeight} L ${padding.left} ${padding.top + innerHeight} Z`;
  const highlightPoint = points[4];

  return (
    <div className="admin-home-visit-chart-wrap">
      <svg className="admin-home-visit-chart" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" aria-hidden="true">
        {[0, 2000, 4000, 6000, 8000, 10000].map((tick) => {
          const y = padding.top + innerHeight - (tick / max) * innerHeight;
          return (
            <g key={tick}>
              <line x1={padding.left} y1={y} x2={padding.left + innerWidth} y2={y} className="admin-home-grid-line" />
              <text x={padding.left - 10} y={y + 4} className="admin-home-axis-label admin-home-axis-label-y">
                {tick === 0 ? "0" : `${tick / 1000}k`}
              </text>
            </g>
          );
        })}
        {points.map((point) => (
          <text key={point.label} x={point.x} y={height - 12} textAnchor="middle" className="admin-home-axis-label">
            {point.label}
          </text>
        ))}
        <path d={areaPath} className="admin-home-area-path" />
        <path d={linePath} className="admin-home-line-path" />
        {points.map((point, index) => (
          <circle key={point.label} cx={point.x} cy={point.y} r={index === 4 ? 5 : 3.5} className={`admin-home-line-dot ${index === 4 ? "is-active" : ""}`} />
        ))}
      </svg>
      <div
        className="admin-home-tooltip"
        style={{ left: `${((highlightPoint.x - padding.left) / innerWidth) * 100}%`, top: `${((highlightPoint.y - padding.top) / innerHeight) * 100}%` }}
      >
        <strong>05-14</strong>
        <span>访问量（UV）：8,763</span>
      </div>
    </div>
  );
}

function TrafficDonut() {
  const segments = [];
  let offset = 0;
  TRAFFIC_SOURCES.forEach((item) => {
    const size = (item.value / 100) * 100;
    segments.push({ ...item, offset, size });
    offset += size;
  });

  return (
    <div className="admin-home-donut-layout">
      <div className="admin-home-donut-shell" aria-hidden="true">
        <svg viewBox="0 0 42 42" className="admin-home-donut-chart">
          <circle cx="21" cy="21" r="15.915" className="admin-home-donut-track" />
          {segments.map((item) => (
            <circle
              key={item.label}
              cx="21"
              cy="21"
              r="15.915"
              className="admin-home-donut-segment"
              stroke={item.color}
              strokeDasharray={`${item.size} ${100 - item.size}`}
              strokeDashoffset={25 - item.offset}
            />
          ))}
        </svg>
        <div className="admin-home-donut-center">
          <span>总访问量</span>
          <strong>56,782</strong>
        </div>
      </div>
      <div className="admin-home-source-list">
        {TRAFFIC_SOURCES.map((item) => (
          <div key={item.label} className="admin-home-source-item">
            <span className="admin-home-source-dot" style={{ background: item.color }} />
            <span>{item.label}</span>
            <strong>{item.value}%</strong>
          </div>
        ))}
      </div>
    </div>
  );
}

function SalesBarChart() {
  return (
    <div className="admin-home-bar-chart">
      <div className="admin-home-bar-axis">
        {[100, 80, 60, 40, 20, 0].map((tick) => (
          <div key={tick} className="admin-home-bar-axis-row">
            <span>{tick === 0 ? "0" : `${tick}k`}</span>
            <div />
          </div>
        ))}
      </div>
      <div className="admin-home-bar-columns">
        {SALES_VALUES.map((value, index) => {
          const isActive = index === 4;
          return (
            <div key={SALES_MONTHS[index]} className="admin-home-bar-column">
              <div className="admin-home-bar-track">
                <div className={`admin-home-bar ${isActive ? "is-active" : ""}`} style={{ height: `${value}%` }} />
                {isActive ? (
                  <div className="admin-home-bar-tooltip">
                    <strong>5月</strong>
                    <span>销售额：¥ 56,782</span>
                  </div>
                ) : null}
              </div>
              <span>{SALES_MONTHS[index]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function StatusBadge({ status }) {
  const toneMap = {
    待付款: "pending",
    待发货: "info",
    已发货: "success",
    已完成: "success",
    已取消: "muted"
  };

  return <span className={`admin-home-status-badge ${toneMap[status] || "muted"}`}>{status}</span>;
}

export default function AdminDashboardHome({
  adminRole,
  profileData,
  onNavigate,
  onLogout,
  onChangeLocale,
  locale = "zh",
  brandCard
}) {
  return (
    <AdminDashboardShell
      adminRole={adminRole}
      profileData={profileData}
      onNavigate={onNavigate}
      onLogout={onLogout}
      onChangeLocale={onChangeLocale}
      locale={locale}
      activeTab="home"
      title="管理后台"
      subtitle="欢迎回来，今天有 6 项重点事项等待处理。"
      brandCard={brandCard}
    >
          <section className="admin-home-stats-grid">
            {STAT_CARDS.map((item) => (
              <StatCard key={item.key} item={item} />
            ))}
          </section>

          <section className="admin-home-grid admin-home-grid-top">
            <article className="admin-home-card admin-home-panel admin-home-panel-wide">
              <div className="admin-home-panel-head">
                <div>
                  <h2>近7日访问趋势</h2>
                  <p>持续监控站点访问热度与波动趋势。</p>
                </div>
                <ChartToolbar items={[{ label: "按日", options: ["按日", "按周", "按月"] }, { label: "日历", icon: "calendar" }, { label: "更多", icon: "more" }]} />
              </div>
              <VisitTrendChart />
            </article>

            <article className="admin-home-card admin-home-panel admin-home-panel-side">
              <div className="admin-home-panel-head">
                <div>
                  <h2>流量来源</h2>
                  <p>查看渠道结构，优化获客投放策略。</p>
                </div>
                <ChartToolbar items={[{ label: "近7日", options: ["近7日", "近30日", "本季度"] }, { label: "更多", icon: "more" }]} />
              </div>
              <TrafficDonut />
            </article>
          </section>

          <section className="admin-home-grid admin-home-grid-bottom">
            <div className="admin-home-main-column">
              <article className="admin-home-card admin-home-panel">
                <div className="admin-home-panel-head">
                  <div>
                    <h2>月度销售统计</h2>
                    <p>按月追踪成交规模，定位增长节点。</p>
                  </div>
                  <ChartToolbar items={[{ label: "2024年", options: ["2024年", "2023年", "2022年"] }, { label: "视图", icon: "view" }, { label: "更多", icon: "more" }]} />
                </div>
                <SalesBarChart />
              </article>

              <article className="admin-home-card admin-home-panel admin-home-table-card">
                <div className="admin-home-panel-head">
                  <div>
                    <h2>最近订单</h2>
                    <p>展示最新成交订单与处理状态。</p>
                  </div>
                  <button type="button" className="admin-home-text-button" onClick={() => onNavigate?.("orders")}>查看全部订单</button>
                </div>
                <div className="admin-home-table-wrap">
                  <table className="admin-home-table">
                    <thead>
                      <tr>
                        <th>订单号</th>
                        <th>客户</th>
                        <th>状态</th>
                        <th>金额</th>
                        <th>时间</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      {RECENT_ORDERS.map((order) => (
                        <tr key={order.id}>
                          <td>{order.id}</td>
                          <td>{order.customer}</td>
                          <td><StatusBadge status={order.status} /></td>
                          <td>{order.amount}</td>
                          <td>{order.time}</td>
                          <td>
                            <button type="button" className="admin-home-link-button" onClick={() => onNavigate?.("orders")}>查看</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="admin-home-pagination">
                  <span>共 128 条</span>
                  <button type="button">10 条/页</button>
                  <button type="button">上一页</button>
                  <button type="button" className="is-current">1</button>
                  <button type="button">2</button>
                  <button type="button">3</button>
                  <button type="button">...</button>
                  <button type="button">13</button>
                  <button type="button">下一页</button>
                  <button type="button">前往 1 页</button>
                </div>
              </article>
            </div>

            <aside className="admin-home-side-column">
              <article className="admin-home-card admin-home-panel">
                <div className="admin-home-panel-head">
                  <div className="admin-home-panel-title-inline">
                    <h2>待办事项</h2>
                    <span className="admin-home-badge danger">6</span>
                  </div>
                  <button type="button" className="admin-home-text-button">全部标记已完成</button>
                </div>
                <div className="admin-home-todo-list">
                  {TODOS.map((item) => (
                    <label key={item.id} className="admin-home-todo-item">
                      <input type="checkbox" />
                      <span className="admin-home-todo-content">
                        <strong>{item.title}</strong>
                        <small>{item.detail}</small>
                      </span>
                      <time>{item.time}</time>
                    </label>
                  ))}
                </div>
                <button type="button" className="admin-home-link-footer">查看全部待办事项</button>
              </article>

              <article className="admin-home-card admin-home-panel">
                <div className="admin-home-panel-head">
                  <div>
                    <h2>系统公告</h2>
                    <p>运营通知与系统动态统一收口。</p>
                  </div>
                  <button type="button" className="admin-home-text-button">更多</button>
                </div>
                <div className="admin-home-announcement-list">
                  {ANNOUNCEMENTS.map((item) => (
                    <article key={item.id} className="admin-home-announcement-item">
                      <div className="admin-home-announcement-head">
                        <span className={`admin-home-tag ${item.tone}`}>{item.tag}</span>
                        <time>{item.date}</time>
                      </div>
                      <strong>{item.text}</strong>
                    </article>
                  ))}
                </div>
              </article>
            </aside>
          </section>
    </AdminDashboardShell>
  );
}